import { Injectable } from '@angular/core';

import { Permissions } from '../../../shared/configs/permissions.config';
import { Role } from '../../../shared/configs/roles.config';
import { UserDetailsService } from '../user-details/user-details.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(private userDetailsService: UserDetailsService) {}

  isActionColumnRequired(requiredPermissionList: Permissions[]): boolean {
    return this.isUserAllowed(requiredPermissionList);
  }

  isToggleDisabled(requiredPermissionList: Permissions[]): boolean {
    return !this.isUserAllowed(requiredPermissionList);
  }

  canAccessDemographicApprovals(): boolean {
    const user = this.userDetailsService.userDetails;

    if (this.isQelSuperAdmin()) {
      return true;
    }

    const roles = user?.roles ?? [];

    if (roles.some((role) => role.name === Role.centreHead)) {
      return true;
    }

    const hasProgramAdminPermission = user?.permissions?.some(
      (permission: any) => permission.name === 'program.administrator',
    );

    return (
      !!hasProgramAdminPermission &&
      roles.some((role: any) => role?.vti_poc === 1 || role?.m_and_e_team === 1)
    );
  }

  hasFullPlacementStageAccess(): boolean {
    return this.isQelSuperAdmin();
  }

  isQelSuperAdmin(): boolean {
    const user = this.userDetailsService.userDetails;

    return (
      Number(user?.is_qel) === 1 && !!user?.roles?.some((role) => role.name === Role.superAdmin)
    );
  }

  isUserAllowed(requiredPermissionList: Permissions[]): boolean {
    if (this.isSuperAdmin()) {
      return true;
    }

    if (requiredPermissionList == null) {
      return true;
    }

    return this.userDetailsService.userDetails.permissions.some((userPermission) =>
      requiredPermissionList.includes(userPermission.name),
    );
  }

  private isSuperAdmin(): boolean {
    return this.userDetailsService.userDetails.roles.some(
      (userRole) => userRole.name === Role.superAdmin,
    );
  }
}
